import React, { useState, useEffect, useContext } from "react";
import {
  AppContainer,
  Container,
  LogoContainer,
  Subitle,
  Title,
  LoginForm,
  Button,
  SomeMargin,
  Link,
} from "./Login.css";
//Components
import InputsLogin from "../../Components/Inputs/Login/InputsLogin";
// Images
import logo from "../../Assets/Images/logoLogin.png";
// Libraries
import { useSelector, useDispatch } from "react-redux";
import { ToastProvider, useToasts } from "react-toast-notifications";
// Actions
import { loginSaga, recoverPasswordSaga } from "../../stores/Login/Action";
import { getIsLoginLoading, getLoginError } from "../../stores/Login/Selector";
import {ErrorContext} from '../../Contexts/ErrorContext'

// Consts
const subtitleText =
  "Simplemente ingrese su dirección de correo electrónico a continuación y le enviaremos un enlace para restablecer su contraseña.";
const forgotPasswordText = "¿Olvidaste tu contraseña?";
const logIn = "Ingresar";
const alreadyRegisterText = "¿Ya estás registrado?¡Ingresar!";
const generateNewPasswordText = "Generar una nueva contraseña";
const introduceEmail = "Ingrese su email";
const passwordText = "Contraseña";
const emailText = "Email";

const button = (text, onClick) => (
  <button
    className={Button}
    name="Ingresar"
    onClick={(e) => {
      e.preventDefault();
      onClick();
    }}
  >
    {text}
  </button>
);

const link = (text, onClick) => (
  <h4 className={Link} {...{ onClick }}>
    {text}
  </h4>
);

const Login = (props) => {
  // States
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoginIn, setIsLoginIn] = useState(true);
  // Functions
  const onRecoverPassword = () => dispatch(recoverPasswordSaga(email));
  const onForgotPassword = () => {
    setIsLoginIn(false);
    setEmail("");
  };
  const dispatch = useDispatch();

  const isLoginLoading = useSelector(getIsLoginLoading);
  const {isMainLoading} = useContext(ErrorContext);
  const style = { cursor: "" };
  if (isLoginLoading || isMainLoading) style.cursor = "progress";

  const Toasts = () => {
    const { addToast } = useToasts();

    const error = useSelector(getLoginError);
    useEffect(() => {
      if (error) addToast(error, { appearance: "error" });
    }, [error]);

    return <div />;
  };

  const loginForm = (
    <form className={LoginForm}>
      <h1 className={Title}>Login</h1>
      <div className={SomeMargin} />
      <InputsLogin
        value={email}
        onChange={setEmail}
        isPassword={false}
        marginBottom={15}
        placeholder={emailText}
      />
      <InputsLogin
        value={password}
        onChange={setPassword}
        isPassword={true}
        marginBottom={15}
        placeholder={passwordText}
      />
      {button(logIn, () => dispatch(loginSaga(email, password)))}
      {link(forgotPasswordText, onForgotPassword)}
    </form>
  );

  const recoverPasswordForm = (
    <form className={LoginForm}>
      <h2 className={Title}>{forgotPasswordText}</h2>
      <h5 className={Subitle}>{subtitleText}</h5>
      <InputsLogin
        value={email}
        onChange={setEmail}
        isPassword={false}
        marginBottom={15}
        placeholder={introduceEmail}
      />
      {button(generateNewPasswordText, onRecoverPassword)}
      {link(alreadyRegisterText, () => setIsLoginIn(true))}
    </form>
  );

  return (
    <div className={AppContainer} style={style}>
      <ToastProvider autoDismiss={true}>
        <Toasts />
      </ToastProvider>
      <img className={LogoContainer} src={logo} alt="Logo" />
      <main className={Container}>
        {isLoginIn ? loginForm : recoverPasswordForm}
      </main>
    </div>
  );
};

export default Login;



// WEBPACK FOOTER //
// ./src/Containers/Login/Login.js